import { Record, Map } from 'immutable';

import prefix from 'OPENTOK/prefix';

export const SUBSCRIBER_STATUS_INIT = prefix('SUBSCRIBER_STATUS_INIT');
export const SUBSCRIBER_STATUS_CONNECTED = prefix('SUBSCRIBER_STATUS_CONNECTED');

const SubscriberRecord = Record({
  id: null,
  sessionId: null,
  streamId: null,
  object: null,
  status: SUBSCRIBER_STATUS_INIT,
  videoElement: null,
  audioStatus: Map({ byPublisher: null, bySubscriber: true }),
  videoStatus: Map({ byPublisher: null, bySubscriber: true, byQuality: true }),
  name: null,
  videoType: 'camera',
  sourceType: 'subscriber',
  audioVolume: undefined,
});

export default class Subscriber extends SubscriberRecord {
  isSubscribed() {
    return this.get('status') !== SUBSCRIBER_STATUS_INIT;
  }

  isConnected() {
    return this.get('status') === SUBSCRIBER_STATUS_CONNECTED && this.get('videoElement');
  }

  isAudioEnabled() {
    const audioStatus = this.get('audioStatus');
    return audioStatus.get('byPublisher') === true && audioStatus.get('bySubscriber') === true;
  }

  isVideoEnabled() {
    const videoStatus = this.get('videoStatus');
    return videoStatus.get('byPublisher') === true && videoStatus.get('bySubscriber') === true && videoStatus.get('byQuality') === true;
  }

  isVideoQualityDegraded() {
    return this.getIn(['videoStatus', 'byQuality']) === false;
  }

}
